var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "id": "address_data_table"
    }
  }, [_vm.title ? _c('v-card-title', [_vm._v(" " + _vm._s(_vm.title) + " "), _c('v-spacer')], 1) : _vm._e(), _c('v-data-table', {
    attrs: {
      "items": _vm.addresses,
      "headers": _vm.headers,
      "multi-sort": "",
      "mobile-breakpoint": 0
    },
    scopedSlots: _vm._u([{
      key: "item.address",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('div', [_vm.links ? [_c('router-link', {
          staticClass: "id",
          attrs: {
            "to": "/address/".concat(item.address)
          }
        }, [_vm._v(_vm._s(item.address))])] : [_vm._v(_vm._s(item.address))]], 2)];
      }
    }, {
      key: "item.avaxBalance",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.avaxBalance) + " ")];
      }
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }